import Snackbar from '@/models/Snackbar';
import { Template } from '@/modules/amDashboard/types';

/**
 * --------------------------------------------------
 *	Root State
 * --------------------------------------------------
 **/
export const RootState: IRootState = {
  snackbar: null,
  globalSource: 'asset-manager,provider,fiduciary,consultant',
  bulkSubmissionTemplateDetails: [],
  batchId: '',
  validatingEntityAccess: false
};

/**
 * --------------------------------------------------
 *	Root State Interface
 * --------------------------------------------------
 **/
export interface IRootState {
  snackbar: Snackbar | null;
  globalSource: string;
  bulkSubmissionTemplateDetails: Template[];
  batchId: string;
  validatingEntityAccess: boolean;
}
